import template from './refineSearchTerm.html';

function refineSearchTerm() {
  return {
    template,
    restrict: 'E',
    scope: {
      filterSet: '=?',
      filter: '=?'
    },
    controller: 'refineSearchTermController',
    replace: true,
    link(scope, element) {
      element.on('focusin', () => {
        element.addClass('focused');
      });

      element.on('focusout', () => {
        element.removeClass('focused');
      });
    }
  };
}

function refineSearchTermController($scope) {
  $scope.filter = $scope.filter || $scope.filterSet.getFilter('searchTerm');
  $scope.viewCopyfilter = angular.copy($scope.filter);

  const initWatcher = $scope.$watch('filter.value', (value) => {
    if (!$scope.viewCopyfilter.value && value) $scope.viewCopyfilter.value = value;
    initWatcher();
  });

  $scope.submitSearch = () => {
    $scope.filter.changeValue($scope.filter.value);
    $scope.viewCopyfilter.value = $scope.filter.value;
  };

  $scope.clearSearch = () => {
    $scope.filter.changeValue(null);
    $scope.viewCopyfilter.value = null;
  };
}

const directiveArr = [
  refineSearchTerm
];

const controllerArr = [
  '$scope',
  refineSearchTermController
];

export default function (ngModule) {
  ngModule.directive('refineSearchTerm', directiveArr);
  ngModule.controller('refineSearchTermController', controllerArr);
}
